"use client";

import { c as _c } from "react/compiler-runtime";
import styles from "./CollectionsDropdown.module.scss";
import { Dropdown } from "react-bootstrap";
import { useRouter } from "next/navigation";
type CollectionType = "memes" | "gradient" | "nextgen" | "memelab" | "rememes";
interface CollectionItem {
  id: CollectionType;
  name: string;
  path: string;
}
const COLLECTIONS: CollectionItem[] = [{
  id: "memes",
  name: "The Memes",
  path: "/the-memes"
}, {
  id: "gradient",
  name: "Gradient",
  path: "/6529-gradient"
}, {
  id: "nextgen",
  name: "NextGen",
  path: "/nextgen"
}, {
  id: "memelab",
  name: "Meme Lab",
  path: "/meme-lab"
}, {
  id: "rememes",
  name: "ReMemes",
  path: "/rememes"
}];
interface Props {
  activePage: CollectionType;
}
export default function CollectionsDropdown(props) {
  const $ = _c(14);
  const router = useRouter();
  let t0;
  if ($[0] !== props.activePage) {
    t0 = COLLECTIONS.find(c => c.id === props.activePage) ?? COLLECTIONS[0];
    $[0] = props.activePage;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const activeCollection = t0;
  let t1;
  if ($[2] !== router) {
    t1 = collectionPath => {
      router.push(collectionPath);
    };
    $[2] = router;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleSelect = t1;
  const t2 = activeCollection?.name;
  let t3;
  if ($[4] !== t2) {
    t3 = <Dropdown.Toggle variant="outline-light">{t2}</Dropdown.Toggle>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== handleSelect || $[7] !== props.activePage) {
    t4 = COLLECTIONS.map(collection => <Dropdown.Item key={`collection-${collection.id}`} active={collection.id === props.activePage} onClick={() => handleSelect(collection.path)}>{collection.name}</Dropdown.Item>);
    $[6] = handleSelect;
    $[7] = props.activePage;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <Dropdown.Menu>{t4}</Dropdown.Menu>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <Dropdown className={styles.collectionsDropdown}>{t3}{t5}</Dropdown>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}